import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import "./ViewPage.css";
import axios from "axios";

const ViewSalarySF = () => {
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { salary_id } = useParams();
  const navigate = useNavigate();

  const [staff, setStaff] = useState(null);

  useEffect(() => {
      axios.post(`${API_BASE_URL}salary_sf_detail.php`,{salary_id:salary_id})
        .then((response) => {
          if (response.data.head.code === 200 ) {
            setStaff(response.data.body);
            // setFilteredOrders(response.data.body);
            // console.log(response.data.body[0]);
  
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            setStaff([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          setStaff([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }, []);

  // useEffect(() => {
  //   // TODO: replace with real fetch by id
  //   const fetchedData = {
  //     id: id || 1,
  //     name: "PRABHA",
  //     designation: "AO",
  //     doj: "17/2/2021",
  //     actualSalary: 30000,
  //     totalDays: 30,
  //     lop: 2,
  //     hraPercent: 20,
  //     epfPercent: 12,
  //     savingsPercent: 7,
  //     istePercent: 0,
  //     others: 0,
  //   };

  //   setStaff(fetchedData);
  // }, [id]);

  // const calculateSalary = (item) => {
  //   const workingDays = item.totalDays - item.lop;
  //   const gross = item.actualSalary;
  //   const basic = gross;
  //   const hra = (gross * item.hraPercent) / 100;
  //   const epf = (gross * item.epfPercent) / 100;
  //   const savings = (gross * item.savingsPercent) / 100;
  //   const iste = (gross * item.istePercent) / 100;
  //   const totalDeduction = epf + savings + item.others;
  //   const netSalary = gross - totalDeduction;

  //   return {
  //     workingDays,
  //     gross,
  //     basic,
  //     hra,
  //     epf,
  //     savings,
  //     iste,
  //     totalDeduction,
  //     netSalary,
  //   };
  // };

  if (!staff) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">View Self Financing Staff Salary</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  // const calc = calculateSalary(staff);

  const fields = [
    { label: "Staff Name", value: staff.name },
    { label: "Designation", value: staff.desig_name },
    { label: "Department", value: staff.depart_name },
    { label: "Date of Joining", value: staff.date_of_join },
    { label: "Actual Salary", value: (<><BiRupee /> {staff.actual}</>) },
    { label: "Total Days", value: staff.total_days },
    { label: "LoP", value: staff.lop },
    { label: "Working Days", value: staff.working_days },
    { label: "HRA %", value: staff.hra_per },
    { label: "EPF %", value: staff.epf_per },
    { label: "Savings %", value: staff.savings_per },
    { label: "ISTE %", value: staff.iste_per },
    { label: "Others", value: staff.others },
    { label: "Gross", value: (<><BiRupee /> {staff.gross}</>) },
    { label: "Basic", value: (<><BiRupee /> {staff.basic}</>) },
    { label: "HRA", value: (<><BiRupee /> {staff.hra_amt}</>) },
    { label: "ISTE", value: (<><BiRupee /> {staff.iste_amt}</>) },
    { label: "EPF", value: (<><BiRupee /> {staff.epf_amt}</>) },
    { label: "Savings", value: (<><BiRupee /> {staff.savings_amt}</>) },
    { label: "Total Deduction", value: (<><BiRupee /> {staff.deduction}</>) },
    { label: "Net Salary", value: (<><BiRupee /> {staff.net_salary}</>) },
  ];

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">View Self Financing Staff Salary</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          {/* optional left column for consistent layout */}
          <div className="customer-photo-wrap" aria-hidden />

          <div className="customer-details-table-wrapper">
            <table
              className="customer-view-table"
              role="table"
              aria-label={`Salary details for ${staff.name}`}
            >
              {/* <thead>
                <tr>
                  <th style={{ width: "36%" }}>Field</th>
                  <th style={{ width: "64%" }}>Value</th>
                </tr>
              </thead> */}
              <tbody>
                {fields.map((f, i) => (
                  <tr key={i}>
                    <td className="field-cell">{f.label}</td>
                    <td className="value-cell">{f.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewSalarySF;
